export function findTemplate(templates, templateId, templateVersion) {
    for (const template of templates) {
        if (template.id == templateId && template.version == templateVersion) {
            return template;
        }
    }
    return null;
}
export function getLatestVersionMap(templates) {
    const latestVersions = {};
    templates.forEach((i) => {
        var _a;
        const templateId = i.id;
        const templateVersion = i.version || 0;
        if (((_a = latestVersions[templateId]) !== null && _a !== void 0 ? _a : -1) < templateVersion) {
            latestVersions[templateId] = templateVersion;
        }
    });
    return latestVersions;
}
export function canUpgrade(templates, templateId, templateVersion) {
    let can = false;
    templates.forEach((i) => {
        if (i.id == templateId && i.version && i.version > templateVersion) {
            can = true;
        }
    });
    return can;
}
export function getLatestVersion(templates, id) {
    let latestVersion = -1;
    let latestTemplate = null;
    templates.forEach((i) => {
        const templateId = i.id;
        if (templateId == id) {
            const templateVersion = i.version || 0;
            if (templateVersion > latestVersion) {
                latestTemplate = i;
                latestVersion = templateVersion;
            }
        }
    });
    return latestTemplate;
}
